import { customerRoutes } from 'noddi-util';
import { useAuthContext } from 'noddi-web';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { NoddiLoadingScreenWithTrans } from '../Loading/NoddiLoadingScreenWithTrans';

export function PrivateRoute() {
  const { isTokenLoadingOnMount, shouldAllowAccess, userData, currentUserGroupId } = useAuthContext();
  const { pathname } = useLocation();

  if (isTokenLoadingOnMount) {
    return <NoddiLoadingScreenWithTrans />;
  }

  if (!shouldAllowAccess) {
    return <Navigate to={customerRoutes.login.getPath()} />;
  }

  // Every private page is scoped to the current group. Without one, the selection page picks
  // it or explains that the account has none, before any page fires a group-less request.
  const userSelectionPath = customerRoutes.userSelection.getPath();
  if (userData && !currentUserGroupId && pathname !== userSelectionPath) {
    return <Navigate replace to={userSelectionPath} />;
  }

  return <Outlet />;
}
